import React, { useEffect, useState } from 'react';
import './CustomInputAlert.scss';
import Confirm from '../../../images/confirm.svg';
import Error from '../../../images/error.svg';
import Warning from '../../../images/warning.svg';
import Exclamation from '../../../images/confirm-image.svg';
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Divider, IconButton, CircularProgress, TextField } from '@mui/material';

const CustomInputAlert = ({ 
    severity, 
    show, 
    header, 
    message, 
    onClick, 
    alertType,
    confirmButton,
    inputLabel = "Enter Value",  // Dynamic label for input field
    autoclose = true,
    multiline=false,
    hideInput=false
}) => {
  
  const [progress, setProgress] = useState(0);
  const [inputValue, setInputValue] = useState("");  // State for input field

  useEffect(() => {
    let timer;
    if (show && autoclose && severity !== "confirm") { 
      setProgress(0);
      timer = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(timer);
            onClick(); 
            return 100;
          }
          return prev + 2; 
        });
      }, 100);
    }
    return () => clearInterval(timer);
  }, [show, onClick, autoclose]);

  useEffect(() => {
    setInputValue(""); // Reset input field when alert opens
  }, [show]);

  if (!show) return null;

  const iconMapping = {
    success: Confirm,
    error: Error,
    warning: Warning,
    confirm: Exclamation
  };

  const className = severity === 'success' ? 'congratulations-message' 
                  : severity === 'error' ? 'error-message' 
                  : 'warning-message';

  const IconComponent = iconMapping[severity] || Error;

  const handleContainerClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Box className="success-box-overlay" onClick={onClick}>
      <Box className="success-box-container" onClick={handleContainerClick}>
        
        {/* Close Button & Timer */}
        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
          <CircularProgress variant="determinate" value={progress} size={40} thickness={4} sx={{ position: "absolute", color: "#6c757d" }} />
          <IconButton onClick={onClick} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Alert Icon */}
        <img src={IconComponent} alt={severity} className="success-icon" loading="lazy" />
        
        {/* Header */}
        <Box className={className}>{header}</Box>

        {/* Message */}
        <Box className="transfer-completed-message" dangerouslySetInnerHTML={{ __html: message?.replace(/\n/g, '<br />') }}></Box>

        {/* Input Field */}
        <Box sx={{ mt: 2, width: "100%", display: hideInput ? 'none' : 'block' }}>
          <TextField
            fullWidth
            label={inputLabel}
            variant="outlined"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            multiline={multiline}
            rows={multiline ? 3 : 1}
          />
        </Box>

        {/* Confirmation Buttons */}
        {alertType === "confirm" && (
          <>
            <Divider sx={{ my: 2, border: "1px solid #A6A6A6", width: "100%" }} />
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, marginTop: 2 }}>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#28a745", color: "white", fontWeight: "bold", fontFamily: "Nunito", "&:hover": { backgroundColor: "#218838" } }}
                onClick={() => { confirmButton(inputValue); onClick(); }} // Pass input value
              >
                YES, CONFIRM!
              </Button>

              <Button
                variant="contained"
                sx={{ backgroundColor: "#dc3545", color: "white", fontWeight: "bold", fontFamily: "Nunito", "&:hover": { backgroundColor: "#c82333" } }}
                onClick={onClick} 
              >
                CANCEL
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default CustomInputAlert;
